import { ClinicAddressInfo } from '../types';

const formatAddressLine = (address: ClinicAddressInfo): string => {
    const { line1, line2, city, state, postalCode } = address;

    let cityState = '';

    if (city) {
        cityState = [city, state].filter((value) => value).join(', ');
    }

    const addressLines = [line1, line2];

    return addressLines
        .concat([cityState, postalCode])
        .filter((value: string) => value)
        .join(' ');
};

export default formatAddressLine;
